import { render, staticRenderFns } from "./MoveCar.vue?vue&type=template&id=4ca334c7&"
import script from "./MoveCar.vue?vue&type=script&lang=js&"
export * from "./MoveCar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports